import { service } from '@ember/service';
import type { Snapshot } from '@ember-data/legacy-compat/-private';
import ApplicationAdapter from 'lumen/adapters/application';
import type { HotelAndMarketServiceWithHotel } from 'lumen/services/hotel-and-market';

export default class RoiTrophiesHighlightConfigAdapter extends ApplicationAdapter {
  @service('hotel-and-market')
  declare hotelAndMarketService: HotelAndMarketServiceWithHotel;

  // The read (queryRecord) keeps using the inherited URL building via
  // `namespace`/`typeKey`. Only the PATCH needs a hand: `save()` doesn't carry
  // the `subscription_id` query param, so we build the write URL ourselves.
  // @ts-expect-error: Property 'buildURL' in type is not assignable to the same property in base type.
  buildURL(
    modelName: string,
    id: string,
    snapshot: Snapshot<unknown>,
    requestType: string,
    query?: Record<string, unknown>,
  ): string {
    if (requestType === 'updateRecord') {
      const subscriptionId = this.hotelAndMarketService.hotel.id;

      return `${this.host}/apigateway/v1/app/highlights/email/settings/?subscription_id=${subscriptionId}`;
    }

    // @ts-expect-error: Expected 3 arguments, but got 5.
    return super.buildURL(modelName, id, snapshot, requestType, query);
  }
}
